export const CST = {
    SCENES: {
        BOOT: "BOOT",
        PRELOAD: "PRELOAD",
        MENU: "MENU",
        TEAMS: "TEAMS",
        NAMES: "NAMES",
        BOARD2: "BOARD2",
        BOARD3: "BOARD3",
        BOARD4: "BOARD4",
        CATEGORY: "CATEGORY",
        QUESTION: "QUESTION",
        STATEMENT: "STATEMENT",
        RULES1: "RULES1",
        RULES2: "RULES2",
        ENDSCREEN: "ENDSCREEN"
    },
    TEXTSTYLES: {
        TITLESTYLE: {fontFamily:  "Arial", fontSize: "50px", color: "#000", fontStyle: "bold"} as Phaser.Types.GameObjects.Text.TextStyle,
        TEAMNAME: {fontFamily:  "Arial", fontSize: "24px", color: "#000", fontStyle: "bold"} as Phaser.Types.GameObjects.Text.TextStyle,
        TEAMLEADERBOARD: {fontFamily:  "Arial", fontSize: "40px", color: "#000"} as Phaser.Types.GameObjects.Text.TextStyle,
        BUTTONSSTYLE: {fontFamily: "Arial", fontSize: "32px", color: "#fff"} as Phaser.Types.GameObjects.Text.TextStyle,
        QUESTIONSTYLE: {fontFamily: "Arial", fontSize: "32px", color: "#000", wordWrap: {width: 1025} as Phaser.Types.GameObjects.Text.TextWordWrap} as Phaser.Types.GameObjects.Text.TextStyle,
        TIMERSTYLE: {fontFamily: "Arial", fontSize: "76px", color: "#000"} as Phaser.Types.GameObjects.Text.TextStyle,
        POINTS: {fontFamily:  "Arial", fontSize: "42px", color: "#000"} as Phaser.Types.GameObjects.Text.TextStyle,
    }
}